import axios from "axios";

export function apiGetCalendrierSalles(bearerTokenApiGraph, formData) {
  return axios
    .post(process.env.REACT_APP_URL_APIGRAPH, formData, {
      headers: {
        bearerToken: bearerTokenApiGraph,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetCalendrierOrgunit(bearerTokenApiGraph, formData) {
  return axios
    .post(process.env.REACT_APP_URL_APIGRAPH, formData, {
      headers: {
        bearerToken: bearerTokenApiGraph,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
